import Card from '../../components/card/Card';
import H from '../../components/texts/h/H';
import TextArea from '../../components/textarea/TextArea';
import { MonetizationFormData, FormValues } from '../../pages/MonetizationNew';

interface ObservationSectionProps {
  formData: MonetizationFormData;
  formValues: FormValues;
  updateFormValues: (updates: Partial<FormValues>) => void;
}

const ObservationSection = ({ formValues, updateFormValues }: ObservationSectionProps) => {
  const handleObservationChange = (e: any) => {
    const value = e.target.value;
    // Limit to 2500 characters
    if (value.length <= 2500) {
      updateFormValues({ observation: value });
    }
  };

  return (
    <Card margin={{ bottom: '4' }}>
      <Card margin={{ bottom: '3' }}>
        <H variant="secondary-2" type='4' weight='bold' modifier='strong'>
          Observaciones
        </H>
      </Card>
      
      {/* Observation TextArea */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px', alignItems: 'end' }}>
        <TextArea
          label="Observación"
          value={formValues.observation || ''}
          onChange={handleObservationChange}
          placeHolder="Ingrese observaciones adicionales (opcional)"
          maxLength={2500}
          rows={4}
          maxLengthHelpText={true}
        />
      </div>
    </Card>
  );
};

export default ObservationSection;